import { FormControl } from '@angular/forms';
import * as _ from 'underscore';

export function VarAssocValidator(control: FormControl) {
    if (control.value && !_.isEmpty(control.value)) {
        for(let prop in control.value){
           if(control.value[prop]=='' || control.value== null){
               return {error: true};
           }
        }
        return null;
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/reactForm-validators/varAssocValidator.ts